<template>
    <div class="approval-box">
        <ul class="approval-list">
            <li class="approval-item" :class="type == 'all' ? 'active' : ''" @click="handleActive('all')">
                <p class="approval-amount"><span>{{ boxData.total }}</span>item(s)</p>
                <span class="approval-note">All</span>
            </li>
            <li class="approval-item" :class="type == 'order_fm' ? 'active' : ''" @click="handleActive('order_fm')">
                <p class="approval-amount"><span>{{ boxData.total_order_fm }}</span>Order(s)</p>
                <span class="approval-note">Work Oder</span>
            </li>
            <li class="approval-item" :class="type == 'pv_fm' ? 'active' : ''" @click="handleActive('pv_fm')">
                <p class="approval-amount"><span>{{ boxData.total_pv_fm }}</span>PV(s)</p>
                <span class="approval-note">PV - FM</span>
            </li>
            <li class="approval-item" :class="type == 'pv_lm' ? 'active' : ''" @click="handleActive('pv_lm')">
                <p class="approval-amount"><span>{{ boxData.total_pv_lm }}</span>PV(s)</p>
                <span class="approval-note">PV - LM</span>
            </li>
            <li class="approval-item" :class="type == 'credit_note_lm' ? 'active' : ''" @click="handleActive('credit_note_lm')">
                <p class="approval-amount"><span>{{ boxData.total_credit_note_lm }}</span>Credit Note(s)</p>
                <span class="approval-note">Credit Note - LM</span>
            </li>
            <li class="approval-item" :class="type == 'offset_lm' ? 'active' : ''" @click="handleActive('offset_lm')">
                <p class="approval-amount"><span>{{ boxData.total_offset_lm }}</span>Offset(s)</p>
                <span class="approval-note">Offset - LM</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'approval-box',
        data() {
            return {
                type: 'all',
                boxData: {
                    total_order_fm: 0,
                    total_pv_fm: 0,
                    total_pv_lm: 0,
                    total_credit_note_lm: 0,
                    total_offset_lm: 0,
                    total: 0
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val, old) {
                if(val && old || !val)
                    this.getAwaitingApprovalBox()
            }
        },
        created() {
            this.getAwaitingApprovalBox();
        },
        methods: {
            getAwaitingApprovalBox() {
                this.$store.dispatch(`AwaitingApprovalController/getAwaitingApprovalBoxTotal`, {
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null
                })
                .then(result => {
                    this.boxData = Object.assign(this.boxData, result)
                })
            },
            handleActive(type_selected) {
                this.type = type_selected;
                this.$emit('selectedType', this.type);
            }
        }
    }
</script>